import { bemClasses } from './bemClasses';
export var createNestedClassName = function (className, nested) {
    return nested
        ? bemClasses.modifier("nested", className)
        : bemClasses.element(className);
};
//# sourceMappingURL=createNestedClassName.js.map